export default __webpack_public_path__ + "static/media/17-bm.53ec4834.webp";